/* eslint-disable */
import BreadCrumb from 'components/BreadCrumb';
import React,{ useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import ButtonV2 from 'components/ButtonV2';
import ButtonNoBorder from 'components/ButtonNoBorder';
import H2 from "components/H2";
import H4 from "components/H4";
import DropdownV2 from "components/DropdownV2";
import ButtonSecondary from 'components/ButtonSecondary';
import DropdownV3 from 'components/DropdownV3';
import { dataCategory,listLanguage, opsiHeader, opsiButton, TypeCTA, TypeQuickReply, UrlTypeCTA, categoryTemplate } from 'containers/NewWaTemplate/ListDropdownData';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import _, { lastIndexOf } from 'lodash';
import Modal from "react-modal";
import { Alert, AlertType } from "utils/Alert";
import TermUseAuth from './termUseAuth';

import { listDomain } from 'utils/listDomain';

// Library
import FeatherIcon from 'feather-icons-react';

// components
import PhoneMediaPreview from "./PhoneMediaPreview"

// services
import applicationSvc from "services/applicationSvc";
import waTemplateSvc from "services/waTemplateSvc";

// style
const Icon = styled.img``;
import Svg from "_assets/svg";
import '../FormCreateTemplate.scss';
import '../../whatsappTemplate.scss';
import './formAuth.scss';
import styled from "styled-components";
import InputDropdown from 'components/InputDropdown';

// image
import ItalicImage from '_assets/svg/italic.svg';
import Boldmage from '_assets/svg/bold.svg';
import IconImage from '_assets/svg/iconText.svg';
import AlertTriangle from '_assets/svg/alert-triangle.svg';
import Autofill from '_assets/svg/autofill.svg';
import CopyCode from '_assets/svg/copy-code.svg';
import InputRightDropdown from 'components/InputRightDropdown';
// import SampleContent from './SampleContent';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
  },
};

function FormAuthentication(props) {
  const {
    isDataForAuthentication, 
    handleSelectAccount, 
    selectedAccountTemplate
  } = props;
  const location = useLocation();
  const [isListAccount, setListAccount] = useState([])
  const [isSelectedAccount, setSelectedAccount] = useState({value:'', name:''})
  const history = useHistory();
  const [isTemplate_name, setTemplate_name] = useState("");
  const [isPreview, setPreview] = useState({});
  const [isErrorTemplateName, setErrorTemplateName] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isDataPost, setDataPost] = useState(null);
  const [isApplicatoinId, setApplicationId] = useState([]);
  const [isSelectedLanguage, setSelectedLanguage] = useState([]);
  const [isFooterMessage, setFooterMessage] = useState({type:'', text:''});
  const [isIndexPage, setIndexPage] = useState(0);
  const [isAddSampleContent, showAddSampleContent] = useState({show: false, isIndexPage: isIndexPage});
  const [isDataWabaID, setDataWabaID] = useState();
  const [timer, setTimer] = useState(null)
  const [isValueCodeDelivery, setValueCodeDelivery] = useState('')
  const [isSecurityRecomendation, setSecurityRecomendation] = useState(false)
  const [isExpiryTime, setExpiryTime] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [isValueExpiryTime, setValueExpiryTime] = useState({
    nameTimes: '', 
    value: '', 
    time: null,
    wording: 'This code expires in'
  })
  const [listTime] = useState([
    {value: 'minutes', name: 'minutes'}, 
    // {value: 'second', name: 'second'}
  ])
  const [isChooseTypeTemplate, setChooseTypeTemplate] = useState([]);
  const [isBreadcrumb, setBreadCrumb] = useState(
    [
      {
        name: 'WhatsApp Template List',
        link: '/new-whatsapp-template',
      },
      {
        name: 'Form Create Template WhatsApp',
        link: '',
      },
    ]
  );

  const [isAutoFill, setAutoFill] = useState({package_name: '', signature_hash: ''})
  const [dataFromLocation, setDataFromLocation] = useState(location?.state?.dataChooseTypeTemplate)

  const [isBodyVariable, setBodyVariable] = useState({
    variable: '123456', 
    text: '',
    recomendationSecurity: ''
    
  })

  useEffect(()=>{
    setListAccount(categoryTemplate)
  }, [])

  const changeInput = (value) =>{
    setValueCodeDelivery(value)
  }

  function handleSearch(e) {
    delayedQuery(
      e
      .replace(/ /g, "_")
      .replace(/[^a-zA-Z0-9_]/g, "")
      .toLowerCase()
    );
  }
  
  const delayedQuery = async (q) => {
    setTemplate_name(q);
    clearTimeout(timer)
    
    const newTimer = setTimeout(async() => {
      onCheckTemplate(q)
    }, 500)
  
    setTimer(newTimer)
  }

  async function onCheckTemplate(ev) {
    if (ev) {
      await waTemplateSvc
        .getTemplateName(ev, isApplicatoinId[0])
        .then((result) => {
          if (result.data.data.available) {
            setErrorTemplateName(false);
          } else {
            setErrorTemplateName(true);
          }
        })
        .catch((error) => { });
    }
  }

  function handleSecurityRecomendation(event){
    setSecurityRecomendation(event)
    if(event){
      listLanguage.forEach((langData) => {
        if(langData.value === dataFromLocation?.language[0].value ||
          langData.value === dataFromLocation?.language){
          setBodyVariable({...isBodyVariable, text: langData.codeSecurityWord, recomendationSecurity : langData.securityWord})
        }
      })
    }else{
      setBodyVariable({...isBodyVariable, recomendationSecurity : ''})
    }
  }

  // INTEGRATION
  useEffect(()=>{
    getAllData();
  }, []);

  async function getAllData() {
    let res = await applicationSvc.getAll();

    if (res.data.data) {
      let data = [];
      res?.data?.data.forEach((element) => {
        data.push(element._id);
      });
      setApplicationId(data);
    }
  }

  useEffect(()=>{
    // let dataFromLocation = location?.state?.dataChooseTypeTemplate;
    if(dataFromLocation?.edit){
      // edit bredcrumbd
      isBreadcrumb[1].name = 'Form Edit Template'
      setBreadCrumb(isBreadcrumb)
      
      let dataStructure = dataFromLocation;
      // console.log('dataStructure', dataStructure)
      // body
      let result1 = dataStructure.body.split("]")[0];
      let result2 = dataStructure.body.split(".")[0];
      let result3 = dataStructure.body.split(".")[1];
      // console.log('dataStructure',result1.substring(1),result2.substring(8))
     
      setBodyVariable({
        variable: result1.substring(1), 
        text: `${result2.substring(8)}. `,
        recomendationSecurity: `${result3}. `
      })

      // button
      let structureButton = dataStructure.button
      structureButton.forEach((item) => {
        if(item.type === 'one_tap'){
          setValueCodeDelivery('autofill')
          setAutoFill({
            package_name: item?.button_info?.package_name, 
            signature_hash: item?.button_info?.signature_hash
          })
        }
        if(item.type === 'copy_code'){
          setValueCodeDelivery('copy_code')
        }

      setFooterMessage({type:'text', text:item?.button_info?.button_text})
      })

      // recomendation
      setSecurityRecomendation(dataStructure.message_security)
      
      setListAccount(categoryTemplate)
      // setLisLanguage(listLanguage)
      setSelectedAccount({
        name:dataFromLocation?.template_category,
        value:dataFromLocation?.template_category
      })
      setChooseTypeTemplate([dataFromLocation])
      setTemplate_name(dataFromLocation?.template_name)
      setDataWabaID(dataFromLocation?.waba_id)

      listLanguage.forEach((langData) => {
        if(langData.value === dataFromLocation?.language){
          setSelectedLanguage({
            name: langData.name,
            value: dataFromLocation?.language,
          });

          // footer
          let structureFooter = dataStructure.footer
          setValueExpiryTime({
            nameTimes: langData.nameTimes, 
            value: langData.nameTimes, 
            time: parseInt(structureFooter?.footer_info?.code_expired),
            wording: structureFooter?.text?.body
          })
          if(structureFooter?.footer_info?.code_expired){
            setExpiryTime(true)
          }
        }
      })
    }else{
      if(dataFromLocation?.language?.length > 0){
        setSelectedLanguage(dataFromLocation?.language[0]);

        listLanguage.forEach((langData) => {
          if(langData.value === dataFromLocation?.language[0].value){
            setValueExpiryTime({...isValueExpiryTime, wording: langData.wording, time: 10, nameTimes: langData.nameTimes})
            setBodyVariable({...isBodyVariable, text: langData.codeSecurityWord, recomendationSecurity : langData.securityWord})
            setFooterMessage({type:'text', text: langData.button_text})
          }
        })
      }

      setValueCodeDelivery('copy_code')

      setListAccount(categoryTemplate)
      // setLisLanguage(listLanguage)
      setSelectedAccount(dataFromLocation?.category)
      setChooseTypeTemplate([dataFromLocation])
      setTemplate_name(dataFromLocation?.templateName)
      setDataWabaID(dataFromLocation?.wabaID)
    }

    if(selectedAccountTemplate){
      setSelectedAccount(selectedAccountTemplate)
    }
  }, [isDataForAuthentication, location])


  const _onSubmit = (status) =>{
    let templateID = '';
    if(dataFromLocation?.edit){
      templateID = location?.state?.id
    }

    const dataPayload = {}
    isChooseTypeTemplate.forEach((item) =>{
      dataPayload.template_category = _.upperCase(isSelectedAccount.value);

      if(Array.isArray(item?.language)){
        item.language.forEach(result => {
          dataPayload.language = result.value;
        })
      }else{
        dataPayload.language = item.language;
      }
     
      dataPayload.source = 'api';
      dataPayload.template_name = isTemplate_name;
      dataPayload.application_id = isApplicatoinId[0]
      dataPayload.template_code_id = templateID;
    })

    // header
    dataPayload.header = {
      type: 'none',
      // text: {
      //   body: ''
      // }
    }
  
    // body
    let bodyPayload = `[${isBodyVariable?.variable}]` + ' ' + `${isBodyVariable?.text}`;
    if(isSecurityRecomendation){
      bodyPayload = bodyPayload + ' ' + isBodyVariable.recomendationSecurity
    }
    dataPayload.body = bodyPayload
    dataPayload.message_security = isSecurityRecomendation

    // footer
    if(isExpiryTime && isValueExpiryTime.wording){
      let newText = isValueExpiryTime.wording;
      const footerPayload = {
        type: "text",
          text: {
            body: newText
          },
          // footer_info: {
          //   code_expired: 10
          // }
      }
      if(isExpiryTime){
        let times = parseInt(isValueExpiryTime.time);
        footerPayload.footer_info = {
          code_expired: times
        }
      }
      dataPayload.footer = footerPayload
    }else{
      dataPayload.footer = {
        type: 'none',
        text: {
          body: ''
        }
      }
    }

    // button
    let buttonPayload = []
    if(isValueCodeDelivery === 'autofill'){
      buttonPayload = []
      buttonPayload.push({
        type: "one_tap",
        button_index: 0,
        button_info: {
          button_text: isFooterMessage.text,
          autofill_text: "Autofill",
          package_name: isAutoFill.package_name,
          signature_hash: isAutoFill.signature_hash
        }
      })
    }
    if(isValueCodeDelivery === 'copy_code'){
      buttonPayload = []
      buttonPayload.push({
        type: "copy_code",
        button_index: 0,
        button_info: {
          button_text: isFooterMessage.text
        }
      })
    }
    dataPayload.button = buttonPayload
  
    if (status == 'draft') {
      dataOnPost({ dataPost: dataPayload, status: status });
    } else if(status == 'save'){
      setOpenModal(true);
      setDataPost({ dataPost: dataPayload, status: status });
    }

  }

  async function dataOnPost(data) {
    let _id = location?.state?.id;

    if (dataFromLocation?.edit) {
      // UPDATE
      // delete data.dataPost.application_id;
      // delete data.dataPost.template_code_id;
      await waTemplateSvc
        .updateDraftTemplate({ template_id: _id, status: data.status }, data.dataPost)
        .then((obj) => {
          if(obj.data.success){
           if (data.status == "draft") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully drafted.'
              )
            } else if (data.status == "save") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully created.'
              )
              setOpenModal(false);
            }
          }else{
            Alert.showStatus(
              'error',
              'Error',
              obj.data.errors.message
            )
          }
          setTimeout(() => {
            history.push("/new-whatsapp-template");
          }, 1500);
        })
        .catch((error) => {
          Alert.showStatus(
            'error',
            'Error',
            error?.message
          )
        });
    } else {
      // POST
      await waTemplateSvc
        .createDraftTemplate(data.status, data.dataPost)
        .then((obj) => {
          if(obj.data.success){
          if (data.status == "draft") {
            Alert.showStatus(
              AlertType.SUCCESS,
              'Success!',
              'WhatsApp template successfully drafted.'
            )
          } else if (data.status == "save") {
            Alert.showStatus(
              AlertType.SUCCESS,
              'Success!',
              'WhatsApp template successfully created.'
            )
            setOpenModal(false);
          }
          }else{
            Alert.showStatus(
              'error',
              'Error',
              obj.data.errors.message
            )
          }
          setTimeout(() => {
            history.push("/new-whatsapp-template");
          }, 1500);
        })
        .catch((error) => {
          Alert.showStatus(
            'error',
            'Error',
            error?.message
          )
        });
    }
  }

  
  async function saveDataSubmit(dataPayload) {
    try {
      let resultData = await waTemplateSvc.createNEWWATemplate(dataPayload)

      if(resultData.data.success) {
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'WhatsApp template successfully created.'
        )
        setOpenModal(false);
      } else {
        Alert.showStatus(
          'error',
          'Error',
          resultData.data.errors.message
        )
      }

      setTimeout(() => {
        history.push("/new-whatsapp-template");
      }, 1500);
    } catch (error) {
      Alert.showStatus(
        'error',
        'Error',
        error?.data?.errors?.message || error?.message || 'Something went wrong'
      )
    }
  }

  async function saveDataUpdate(template_id, dataPayload) {
    delete dataPayload.application_id;
    delete dataPayload.template_code_id;

    try {
      let resultData = await waTemplateSvc.updateNEWWATemplate(template_id, dataPayload)

      if(resultData.data.success) {
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'WhatsApp template successfully created.'
        )
        setOpenModal(false);
      } else {
        Alert.showStatus(
          'error',
          'Error',
          resultData.data.errors.message
        )
      }

      setTimeout(() => {
        history.push("/new-whatsapp-template");
      }, 1500);
    } catch (error) {
      Alert.showStatus(
        'error',
        'Error',
        error?.data?.errors?.message || error?.message || 'Something went wrong'
      )
    }
  }
  // END INTEGRATION

  return (
    <div className='container_whatsapp h-100 auth'>
    <Modal
      isOpen={isOpenModal}
      // onRequestClose={()=>setOpenModal(false)}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="modal-submit mb-2">
        <div className="title mb-2">Is the template you want to submit correct?</div>
        <div className="wording">
          Make sure the template you submitted does not contain inappropriate or unlawful words in
          Indonesia. For more details please read the Terms and Conditions of WhatsApp broadcast.
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-center mt-5">
        <div onClick={() => setOpenModal(false)} className="me-3 btn-secondary-template">
          I'm not sure
        </div>
        <div disabled={isLoading} onClick={() => dataOnPost(isDataPost)} className="btn-primary-template">
          Yes, Submit
        </div>
      </div>
    </Modal>
    {/* <ConfirmModalSubmit isOpenModal={isOpenModalSubmit} setOpenModal={setOpenModalSubmit}/> */}
    <div className='row d-flex align-items-center justify-content-between'>
      <div className='col-7'>
        <h3 className='fsize-24 title_custom_700'>{dataFromLocation?.edit ? 'Edit Template' : 'Create Template'}</h3>
        <BreadCrumb dataBreadCrumb={isBreadcrumb} className="mb-4" />
      </div>
      <div className='col-5'>
        <div className='d-flex align-items-center justify-content-end'>
          <div className='me-3 d-none'>
            <ButtonSecondary 
              handleRoute={()=>showAddSampleContent({show: true, isIndexPage: isIndexPage})}
              backgroundColor="#FFFFFF"
              textColor="#312F30"
              padding=".360rem 1rem"
            >
              Add Sample
            </ButtonSecondary>
          </div>
          <div className='me-3'>
            <ButtonSecondary 
              handleRoute={()=>_onSubmit('draft')}
              backgroundColor="#FFFFFF"
              textColor="#312F30"
              padding=".360rem 1rem"
              disabled={isLoading}
            >
              Save as Draft
            </ButtonSecondary>
          </div>
          <div>
            <ButtonV2 
              handleRoute={()=>_onSubmit('save')}
              backgroundColor="#3B3B47"
              textColor="#FFFFFF"
              padding=".360rem 1rem"
            >
                Submit
            </ButtonV2>
          </div>
        </div>
      </div>

    </div>
    <div className='wrapper_content_form'>
      <div className='header w-100'>
        <div className='d-flex align-items-center w-100'>

          {/* Template name */}
          <div className='d-flex align-items-center'>
            <label className='fsize-14 fweight-500 cl-weight-grey d-block me-3'>
              Template Name
            </label>
            <div>
              <div className='template_name_input'>
                <input 
                  value={isTemplate_name}
                  onChange={(e) => handleSearch(e.target.value)}
                  type='text' 
                  className={`${dataFromLocation?.edit && 'event_disable'}cl-neutral500 fsize-14 fweight-400 form-control`}
                  placeholder='Template Name...' 
                />
                <span className='template_length fsize-12 cl-dark-grey fweight-400'>{isTemplate_name?.length} / 512</span>
              </div>
              {isErrorTemplateName && 
              <span className="cl-red fsize-12 fweight-400 mt-1">
                Template name is already used. Please use other template name!
              </span>
              }
            </div>
          </div>
          <div className='border_height mx-3'></div>
          {/* Type Template / Category */}
          {dataFromLocation?.edit && 
          <div className='wrapp_category d-flex align-items-center'>
            <div className='fsize-14 fweight-500 cl-neutral400 d-flex align-items-center justify-content-between'>
              <label className='fsize-14 fweight-500 cl-weight-grey d-block me-2'>Category </label>
              {/* <div className='ms-1'>
                {_.startCase(isSelectedAccount.name)}
              </div> */}
              <div>
                <DropdownV3 
                  className="ms-1 event_disable"
                  isListSearch={isListAccount} 
                  setSelectedSearch={handleSelectAccount} 
                  isSelected={isSelectedAccount}
                  placeholder="Select Account"
                />
              </div>
            </div>
            <div className='border_height  ms-4 me-2'></div>
            <div className={`${
              dataFromLocation?.status === 'InReview' ? 'InReview' : 
              dataFromLocation?.status === 'IN_APPEAL' ? 'InReview' : 
              dataFromLocation?.status === 'Requested' ? 'requested' : 
              dataFromLocation?.status === 'DISABLED' ? 'requested' : 
              dataFromLocation?.status === 'Active' ? 'active-high' : 
              dataFromLocation?.status === 'REJECTED' ? 'rejected' : 
              dataFromLocation?.status === 'active-low' ? 'active-low' : 
              dataFromLocation?.status === 'PAUSED' ? 'paused' : 
              dataFromLocation?.status === 'PENDING' ? 'pending' : 
              dataFromLocation?.status === 'APPROVED' ? 'active-high' : 
              dataFromLocation?.status === 'Draft' ? 'pending' : 
              ''
            } fweight-600 fsize-12 ms-2`}>
              {_.startCase(dataFromLocation?.status)}
            </div>
            <div className='border_height  ms-4 me-2'></div>
          </div>
          }

          {!dataFromLocation?.edit && 
            <div className='fsize-14 fweight-500 cl-neutral400 d-flex align-items-center justify-content-between'>
              <label className='fsize-14 fweight-500 cl-weight-grey d-block me-2'>Category </label>
              <div>
                <DropdownV3 
                  className="ms-2"
                  isListSearch={isListAccount} 
                  setSelectedSearch={handleSelectAccount} 
                  isSelected={isSelectedAccount}
                  placeholder="Select Account"
                />
              </div>
              <div className='border_height ms-4 me-2'></div>
            </div>
          }

          {/* Language */}
          <div className='d-flex align-items-center wrapp_language px-2'>
            <span className='elipsis me-2'></span>
            <span className='fsize-14 fweight-500 cl-neutral400'>{_.startCase(isSelectedLanguage?.name)}</span>
          </div>
        </div>
        {isSelectedAccount.value === 'authentication' &&
          <TermUseAuth></TermUseAuth>
        }
      </div>
      <div className='content'>
          <div className={`row form-fields justify-content-between`}>
            <div className="col-xl-8 col-md-7 pr-xl-4">
              <div className='row'>
                <div className='col-12'>
                  <div className="wrapper_input_template mb-4 position-relative">
                    <div className="d-flex align-items-center mb-2">
                      <h4 className="cl-neutral400 fweight-700 fsize-14 mb-0">Code Delivery</h4>
                    </div>
                    <div className="cl-neutral100 mb-2 fsize-12 fweight-400">
                      Choose how customers send the code from WhatsApp to your app.  Learn how to send <a href='https://developers.facebook.com/docs/whatsapp/business-management-api/authentication-templates/' className='cl-red'> authentication message templates. </a>
                    </div>
                    {/* <div 
                      className={`box_linked cursor-pointer mb-3 ${isValueCodeDelivery === 'autofill' && 'active_border'}`} >
                      <div className={`d-flex flex-column`}>
                        <div className="check-radio-auth elipsis_custom d-flex align-items-center fweight-600 fsize-16 cl-grey-black break-word mb-2">
                          <input
                            onChange={()=>changeInput('autofill')} 
                            // value={item.id}
                            checked={isValueCodeDelivery === 'autofill'}
                            // key={item.value}
                            type="radio" 
                            name='autofill'
                            className={`mr-10-desktop`}
                          />
                          <label 
                            className={`d-flex align-items-center mr-10-desktop small fweight-600 fsize-14 cl-grey-black`}
                            htmlFor="custom-time"
                          >
                            <img src={Autofill} alt='auto-fill' className='ms-2' />
                            <span className='ms-2 me-1'>Autofill</span>
                            <div className='position-relative ms-1'>
                              <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id="button-tooltip-2">
                                    Autofill only works when your customer requests a code on the same device that contains their WhatsApp account.
                                      <br></br>
                                    If autofill is not possible, a copy code message will be sent
                                  </Tooltip>}
                                >
                                  <span className='ic_info d-flex align-items-center'>
                                    <FeatherIcon className="cl-light-grey pinkic-hover" icon="info" />
                                  </span>
                              </OverlayTrigger>
                            </div>
                          </label>
                        </div>
                        <p className={`ms-4 fweight-400 fsize-12 cl-grey mb-4`}>
                          Recommended as the easiest option for your customers. The code is sent to your app when a customer taps the button. A copy code message will be sent when auto-fill isn't possible.
                        </p>
                        {isValueCodeDelivery === 'autofill' && 
                        <div className='ms-4'> 
                            <div className="form-group">
                                <label className='fweight-500 fsize-14 cl-grey-black mb-2'>Package Name</label>
                                <input
                                  value={isAutoFill.package_name}
                                  onChange={(e) => setAutoFill({ ...isAutoFill, package_name: e.target.value})}
                                  type="text"
                                  placeholder="Enter text (com.example.myapplication)"
                                  error=""
                                  className="form-control fsize-14 fweight-400"
                                  maxLength={25}
                                />
                            </div>
                            <div className="form-group">
                                <label className='fweight-500 fsize-14 cl-grey-black mb-2'>App signature hash</label>
                                <input
                                  value={isAutoFill.signature_hash}
                                  onChange={(e) => setAutoFill({ ...isAutoFill, signature_hash: e.target.value})}
                                  type="text"
                                  placeholder="Enter text "
                                  error=""
                                  className="form-control fsize-14 fweight-400"
                                  maxLength={25}
                                />
                            </div>
                          </div>
                        }
                      </div>
                    </div> */}
                    <div 
                      className={`box_linked cursor-pointer mb-3 ${isValueCodeDelivery === 'copy_code' && 'active_border'}`} >
                      <div className={`d-flex flex-column`}>
                        <div className="check-radio-auth elipsis_custom d-flex align-items-center fweight-600 fsize-16 cl-grey-black break-word mb-2">
                          <input
                            onChange={()=>changeInput('copy_code')} 
                            checked={isValueCodeDelivery === 'copy_code'}
                            type="radio" 
                            name='copy_code' 
                            className={`mr-10-desktop`}
                          />
                          <label 
                            className={`d-flex align-items-center mr-10-desktop small fweight-600 fsize-14 cl-grey-black`}
                            htmlFor="custom-time"
                          >
                            <img src={CopyCode} alt='copy-code' className='ms-2' />
                            <span className='ms-2 me-1'>Copy Code</span>
                            <div className='position-relative ms-1'>
                              <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id="button-tooltip-2">The customer taps the button to copy the code and then they paste it in your app. <br></br>
                                  Copy code will be very useful for customers who request code on a device that doesn't contain their whatsapp account.</Tooltip>}
                                >
                                  <span className='ic_info d-flex align-items-center'>
                                    <FeatherIcon className="cl-light-grey pinkic-hover" icon="info" />
                                  </span>
                              </OverlayTrigger>
                            </div>
                          </label>
                        </div>
                        <p className={`ms-4 fweight-400 fsize-12 cl-grey mb-2`}>
                          Basic authentication with quick setup. Your customers copy and paste the code into your app.  
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="wrapper_input_template mb-4 position-relative">
                    <div className="d-flex align-items-center mb-2">
                      <h4 className="cl-neutral400 fweight-700 fsize-14 mb-0">Button Text</h4>
                    </div>
                    <div className="cl-neutral100 mb-2 fsize-12 fweight-400">
                      You can customise the button text for both auto-fill and copy code. Even when zero-tap is turned on, buttons are still needed for the backup code delivery method.
                    </div>
                    <div className="w-100 wrapper_count_textarea">
                      <div className="form-group">
                        <div className="w-100 wrapper_input_count">
                          <input
                            onChange={(event)=>setFooterMessage({type: 'text', text: event.target.value})}
                            value={isFooterMessage.text}
                            type="text"
                            placeholder="Enter text here"
                            error=""
                            className="form-control"
                            maxLength={25}
                          />
                          <span className="count-char">{isFooterMessage?.text?.length}/25</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wrapper_input_template mb-4 position-relative">
                    <div className="d-flex align-items-center mb-2">
                      <h4 className="cl-neutral400 fweight-700 fsize-14 mb-0">Message Content</h4>
                    </div>
                    <div className="cl-neutral100 mb-2 fsize-12 fweight-400">
                      Add a short line of text to the bottom of your message template.
                    </div>
                    <div className="item-dropdown-filter check-checkbox-auth mb-2">
                        <input className="checkbox-custom checkbox-effect checkbox-effect-1" type="checkbox" 
                          onChange={(e) => handleSecurityRecomendation(e.target.checked)} 
                          value={isSecurityRecomendation} 
                          checked={isSecurityRecomendation}
                          name='security'/>
                        <label>Add security recommendation</label>
                    </div>
                    <div>
                      <div className="item-dropdown-filter check-checkbox-auth mb-2">
                          <input className="checkbox-custom checkbox-effect checkbox-effect-1" type="checkbox" 
                            onChange={(e) => setExpiryTime(e.target.checked)} 
                            value={isExpiryTime} 
                            checked={isExpiryTime}
                            name='expiry_time'/>
                          <label>Add expiry time for the code.</label>
                      </div>
                      <div className={`mt-3 w-45 ${!isExpiryTime && 'd-none'}`}>
                        <h4 className="cl-neutral400 fweight-700 fsize-14 mb-2">Code expiry time</h4>
                        <div className="form-group w-50">
                          <div className="w-100 wrapper_input_count">
                            <input
                              onChange={(event)=>setValueExpiryTime({
                                ...isValueExpiryTime, 
                                time: event.target.value
                              })}
                              value={isValueExpiryTime.time}
                              type="number"
                              placeholder="Enter here"
                              error=""
                              className="form-control pe-2"
                              maxLength={25}
                            />
                            <span className="count-char cl-black me-4 fsize-14">{isValueExpiryTime.nameTimes}</span>
                          </div>
                        </div>
                        {/* <InputRightDropdown 
                          typeInput="text"
                          customClass="country_code" 
                          isListSearch={listTime} 
                          setSelectedSearch={(event)=>setValueExpiryTime({...isValueExpiryTime, name: event.value, value: event.value})} 
                          isSelected={isValueExpiryTime}
                          placeholder="None"
                          valueInput={isValueExpiryTime.time}
                          onChange={(event) =>
                            setValueExpiryTime({
                              ...isValueExpiryTime, time: event
                            })
                          }
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-5 pr-0">
              <PhoneMediaPreview 
                isFooterMessage={isFooterMessage}
                onPreview={isPreview} 
                chooseData={isChooseTypeTemplate} 
                isIndexPage={isIndexPage} 
                className="sticky"
                isBodyVariable={isBodyVariable}
                isValueCodeDelivery={isValueCodeDelivery}
                isValueExpiryTime={isValueExpiryTime}
                isExpiryTime={isExpiryTime}
                isSecurityRecomendation={isSecurityRecomendation}
                >
              </PhoneMediaPreview>
            </div>
          </div>
      </div>
    </div>
  
  </div>
  )
}

export default FormAuthentication